import React from "react";
import * as Mui from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { themes } from "services/constants";
// import { rowEndStyle } from "services/constants/Styles";
// import DesktopAccessDisabledIcon from "@mui/icons-material/DesktopAccessDisabled";
export const InsufficientPermissions = () => {
  return (
    <Mui.Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="80vh"
      bgcolor="#ffffff"
    >
      <Mui.Paper
        elevation={0}
        sx={{ maxWidth: 500,textAlign: "center" }}
      >
        {/* Header */}
        <Mui.Typography
          variant="h3"
          fontWeight="bold"
          mb={1}
          color={themes.primaryIndicator}
        >
          Organflow
        </Mui.Typography>

        {/* Title */}
        <Mui.Typography variant="h5" mb={1}>
          You need access
        </Mui.Typography>

        {/* Subtext */}
        <Mui.Typography variant="body2" mb={2}>
          You do not have permission to access these records. Please contact
          your administrator for access. If you need further assistance, reach
          out to support team
        </Mui.Typography>
        {/* Button */}
        <Mui.Button variant="contained" color="primary">
          Request access Your Admin
        </Mui.Button>

        {/* Lock icon on the side */}
        <Mui.Box mt={4} display="flex" justifyContent="center">
          <LockIcon sx={{ fontSize: 80, color: "#4285F4" }} />
        </Mui.Box>
      </Mui.Paper>
    </Mui.Box>
  );
};


    // <React.Fragment>
    //   <Mui.Grid
    //     container
    //     justifyContent="center"
    //     alignItems="center"
    //     sx={{ height: "80vh",paddingLeft:20,paddingRight:20 }}
    //   >
    //     <Mui.Grid
    //       container
    //       sx={{ border: `3px solid ${themes.sidebarDivider}`, padding: 4 }}
    //     >
    //       <Mui.Grid xs={4} sx={{ ...rowEndStyle, paddingRight: 2,paddingTop:-2 }}>
    //         <DesktopAccessDisabledIcon
    //           fontSize="large"
    //           sx={{ fontSize: 60, color: themes.sidebarDivider }}
    //         />
    //       </Mui.Grid>
    //       <Mui.Grid xs={5}>
    //         <Mui.Typography sx={{ fontSize: 30, fontWeight: "bold" }}>
    //           Insufficient Permissions
    //         </Mui.Typography>
    //         <Mui.Typography>
    //           You do not have permission to access these records. Please contact
    //           your administrator for access. If you need further assistance,
    //           reach out to support team
    //         </Mui.Typography>
    //       </Mui.Grid>
    //     </Mui.Grid>
    //   </Mui.Grid>
    // </React.Fragment>